import React from 'react'

const NoofSeasonsandEpisodes = props => {
  const { inputData, sendNoofEpisodes, sendBooleanValueChangeDone } = props

  const stopwheelAction = event => {
    event.target.blur()
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div>
      <label htmlFor='noofepisodes'>
        No of Episodes:<span className='mandatory'>*</span>
      </label>
      <input
        type='number'
        id='noofepisodes'
        name='noofepisodes'
        className='rounded'
        value={inputData.noOfEpisodes}
        onChange={event => {
          sendBooleanValueChangeDone('noOfEpisodes', true)
          sendNoofEpisodes('noOfEpisodes', event.target.value)
        }}
        onWheel={event => stopwheelAction(event)}
      />
      {inputData.noOfEpisodes === '' && (
        <span className='mandatory1'>Number of episodes is mandatory</span>
      )}
    </div>
  )
}

export default NoofSeasonsandEpisodes
